import { PRESC_DESC_URL } from '../../constants/defaults';

export const getMainStoreLdJson = () => {
  let host = 'https://www.singlecare.com';
  let structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    url: host + '/prescription-discount-card',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        url: host + '/prescription-discount-card/cvs',
        name: 'CVS Prescription Discount Card',
        image: host + '/content/images/pharmacy-images/logo-color-cvs.svg'
      },
      {
        '@type': 'ListItem',
        position: 2,
        url: host + '/prescription-discount-card/target',
        name: 'Target Prescription Discount Card',
        image: host + '/content/images/pharmacy-images/Target_CVS.png'
      },
      {
        '@type': 'ListItem',
        position: 3,
        url: host + '/prescription-discount-card/walmart',
        name: 'Walmart Prescription Discount Card',
        image: host + '/content/images/pharmacy-images/logo-color-walmart.svg'
      },
      {
        '@type': 'ListItem',
        position: 4,
        url: host + '/prescription-discount-card/walgreens',
        name: 'Walgreens Prescription Discount Card',
        image: host + '/content/images/pharmacy-images/logo-color-walgreens.svg'
      },
      {
        '@type': 'ListItem',
        position: 5,
        url: host + '/prescription-discount-card/kroger',
        name: 'Kroger Prescription Discount Card',
        image: host + '/content/images/pharmacy-images/logo-color-kroger.svg'
      },
      {
        '@type': 'ListItem',
        position: 6,
        url: host + '/prescription-discount-card/albertsons',
        name: 'Albertsons Prescription Discount Card',
        image:
          host + '/content/images/pharmacy-images/logo-color-albertsons.svg'
      },
      {
        '@type': 'ListItem',
        position: 7,
        url: host + '/prescription-discount-card/longs-drugs',
        name: 'Longs Drugs Prescription Discount Card',
        image: host + '/content/images/pharmacy-images/logo-color-longs.svg'
      },
      {
        '@type': 'ListItem',
        position: 8,
        url: host + '/prescription-discount-card/walmart-neighborhood-market',
        name: 'Walmart Neighborhood Market Prescription Discount Card',
        image:
          host +
          '/content/images/pharmacy-images/logo-color-walmart-nbh-market.svg'
      },
      {
        '@type': 'ListItem',
        position: 9,
        url: host + '/prescription-discount-card/sav-on',
        name: 'Sav-On Prescription Discount Card',
        image:
          host + '/content/images/pharmacy-images/logo-color-savon-pharmacy.svg'
      },
      {
        '@type': 'ListItem',
        position: 10,
        url: host + "/prescription-discount-card/fry's",
        name: "Fry's Prescription Discount Card",
        image: host + '/content/images/pharmacy-images/logo-color-frys.svg'
      },
      {
        '@type': 'ListItem',
        position: 11,
        url: host + '/prescription-discount-card/harris-teeter',
        name: 'Harris Teeter Prescription Discount Card',
        image:
          host + '/content/images/pharmacy-images/logo-color-harristeeter.svg'
      }
    ]
  };
  return JSON.stringify(structuredData);
};
export const getStoreLdJson = storeType => {
  let structuredData = {
    '@context': 'http://schema.org/',
    '@type': 'Thing',
    name: `${storeType} Prescription Discount Card`,
    description: `SingleCare's ${storeType} prescription discount card can help you save up to 80% on your prescription drugs at ${storeType}.`,
    mainEntityOfPage: `${PRESC_DESC_URL}/${storeType}`,
    alternateName: `${storeType} Pharmacy Discount Card`
  };
  return JSON.stringify(structuredData);
};
